export default __webpack_public_path__ + "30546c0482273dc14a4fe2bafceaec23.svg";